import Heading from "shared/ui/typography/Heading";
import { concatClassnames } from "shared/utils/concatClassnames";

interface StandardProductReceiveMethodsHeaderProps {
  className?: string;
}

const StandardProductReceiveMethodsHeader = ({
  className,
}: StandardProductReceiveMethodsHeaderProps) => {
  return (
    <Heading
      headingLevel="h2"
      className={concatClassnames("gg-text-2xl gg-mb-1", className)}
    >
      Hoe wil jij jouw bestelling ontvangen?
    </Heading>
  );
};
export default StandardProductReceiveMethodsHeader;
